import {Card, CardContent, Grid} from '@material-ui/core';
import {Formik, FormikHelpers, FormikProps} from 'formik';
import {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {EnvironmentType} from '../../../../shared/model/EnvironmentType.model';
import {TransHelper} from '../../../../utils/trans-helper';
import NxButton from '../../../shared/nxButton/NxButton';
import {SETTINGS_ERROR_KEY} from '../../Settings';
import {EnvironmentsFormFields} from '../Environment.form.model';
import {Environment} from '../Environment.model';
import styles from './CustomEnvironementSettings.module.scss';
import {
  CustomEnvironmentAttributes,
  CustomEnvironmentFormFields,
  customEnvsFormInitValues,
  customEnvsFormValidationSchema
} from './CustomEnvironmentSettings.model';
import CustomSettingsEnvironmentForm from './CustomSettingsEnvironmentsFields';

type CustomEnvironmentSettingsProps = {
  environments: Array<Environment<CustomEnvironmentAttributes>>;
  submitEnvironments: (
    values: EnvironmentsFormFields<CustomEnvironmentFormFields>,
    actions: FormikHelpers<EnvironmentsFormFields<CustomEnvironmentFormFields>>
  ) => Promise<void>;
};

const PrefixTrans = TransHelper.getPrefixedTrans('SETTINGS.ENVIRONMENT');

export default function CustomEnvironmentSettings({
  environments,
  submitEnvironments
}: CustomEnvironmentSettingsProps): ReactElement {
  const {t} = useTranslation();

  return (
    <Formik enableReinitialize={true}
      initialValues={customEnvsFormInitValues(environments)}
      onSubmit={submitEnvironments}
      validateOnMount={false}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={customEnvsFormValidationSchema(t)}>
      {({
        handleSubmit,
        setFieldValue,
        values,
        errors,
        isSubmitting
      }: FormikProps<EnvironmentsFormFields<CustomEnvironmentFormFields>>): ReactElement => {
        return (
          <form onSubmit={handleSubmit}>
            <Grid container className={styles.root}>
              <Grid item xs={6} className={styles.item}>
                <Card className={styles.card}>
                  <CardContent className={styles.cardContent}>
                    <div className={styles.itemTitle}>
                      <PrefixTrans>SANDBOX</PrefixTrans>
                    </div>
                    <CustomSettingsEnvironmentForm
                      environmentType={EnvironmentType.SANDBOX}
                      values={values}
                      setFieldValue={setFieldValue} />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} className={styles.itemBorder}>
                <Card className={styles.card}>
                  <CardContent className={styles.cardContent}>
                    <div className={styles.itemTitle}>
                      <PrefixTrans>PRODUCTION</PrefixTrans>
                    </div>
                    <CustomSettingsEnvironmentForm
                      environmentType={EnvironmentType.PRODUCTION}
                      values={values}
                      setFieldValue={setFieldValue} />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} className={styles.item}>
                <div className={styles.error}>{errors[SETTINGS_ERROR_KEY]}</div>
              </Grid>
            </Grid>
            <div className={styles.buttonRow}>
              <NxButton className={styles.button} loaded={!isSubmitting} type='submit'>
                <PrefixTrans>SAVE_ENVIRONMENT</PrefixTrans>
              </NxButton>
            </div>
          </form>
        );
      }}
    </Formik>
  );
}
